import { useSyncExternalStore } from "react"
import type { ContentMemberContext } from "./types"

export type HelpCenterPreviewState = {
  active: boolean
  memberContextOverrides: ContentMemberContext | null
}

const initialState: HelpCenterPreviewState = { active: false, memberContextOverrides: null }

let state: HelpCenterPreviewState = initialState
const listeners = new Set<() => void>()

function emit(): void {
  listeners.forEach((listener) => listener())
}

function subscribe(listener: () => void): () => void {
  listeners.add(listener)
  return () => {
    listeners.delete(listener)
  }
}

function getSnapshot(): HelpCenterPreviewState {
  return state
}

export function setHelpCenterPreview(next: Partial<HelpCenterPreviewState>): void {
  state = { ...state, ...next }
  emit()
}

export function resetHelpCenterPreview(): void {
  if (state === initialState) return
  state = initialState
  emit()
}

export function useHelpCenterPreview(): HelpCenterPreviewState {
  return useSyncExternalStore(subscribe, getSnapshot)
}
